import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProjectPage from './pages/ProjectPage';
import NewsPage from './pages/NewsPage';
import PublicationsPage from './pages/PublicationsPage';
import ReadingGroupPage from './pages/ReadingGroupPage';
import OpenSourcePage from './pages/OpenSourcePage';
import OtherProjectsPage from './pages/OtherProjectsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import JoiningPage from './pages/JoiningPage';
import PeoplePage from './pages/PeoplePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<OtherProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/research/publications" element={<PublicationsPage />} />
        <Route path="/research/reading-group" element={<ReadingGroupPage />} />
        <Route path="/projects/open-source" element={<OpenSourcePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/lab/join" element={<JoiningPage />} />
        <Route path="/lab/people" element={<PeoplePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
